// extracted by mini-css-extract-plugin
export var orderSummary = "_tg-0";
export var showMoreLessButton = "_tg-1";